import Vue from 'vue'
import Router from 'vue-router'
import store from './store/index'

store.dispatch(
  'root/setIsLoggedFlag',
  parseInt(localStorage.getItem('isLogged'))
)
store.dispatch('root/populateAuthState')

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/',
      redirect: '/calls'
    },
    {
      path: '/login',
      name: 'login',
      meta: { requiresAuth: false, layout: 'login-layout' },
      component: () =>
        import(/* webpackChunkName: "calls" */ './views/Login.vue')
    },
    {
      path: '/password/email',
      name: 'passwordResetEmail',
      meta: { requiresAuth: false, layout: 'login-layout' },
      component: () =>
        import(/* webpackChunkName: "calls" */ './views/ForgotPassword.vue')
    },
    {
      path: '/password/reset/:username/:token',
      name: 'passwordReset',
      meta: { requiresAuth: false, layout: 'login-layout' },
      component: () =>
        import(/* webpackChunkName: "calls" */ './views/ResetPassword.vue')
    },
    {
      path: '/welcome/:username/:token',
      name: 'welcome',
      meta: { requiresAuth: false, layout: 'login-layout' },
      component: () =>
        import(/* webpackChunkName: "calls" */ './views/Welcome.vue')
    },
    {
      path: '/calls',
      name: 'calls',
      meta: { requiresAuth: true },
      component: () => import('./views/Calls.vue'),
      children: [
        {
          path: 'active',
          name: 'activeCall',
          meta: { requiresAuth: true },
          component: () => import('./components/ActiveCall.vue')
        },
        {
          path: 'list',
          name: 'callsList',
          meta: { requiresAuth: true },
          component: () => import('./components/CallsList.vue')
        }
      ]
    },
    {
      path: '/calls/all',
      name: 'allCalls',
      meta: { requiresAuth: true },
      component: () =>
        import(/* webpackChunkName: "calls" */ './views/Calls.vue')
    },
    {
      path: '/call/:id',
      name: 'callDetail',
      meta: { requiresAuth: true },
      component: () =>
        import(/* webpackChunkName: "calls" */ './views/CallDetail.vue')
    },
    {
      path: '/call/:id/complete',
      name: 'callComplete',
      meta: { requiresAuth: true },
      component: () =>
        import(/* webpackChunkName: "calls" */ './views/CallComplete.vue')
    },
    {
      path: '/media',
      name: 'media',
      meta: { requiresAuth: true },
      component: () =>
        import(/* webpackChunkName: "media" */ './views/Media.vue')
    },
    {
      path: '/scans',
      name: 'scans',
      meta: { requiresAuth: true },
      component: () =>
        import(/* webpackChunkName: "scans" */ './views/Scans.vue')
    },
    {
      path: '/camera/:media',
      name: 'camera',
      meta: { requiresAuth: true },
      component: () =>
        import(/* webpackChunkName: "camera" */ './views/Camera.vue')
    },
    {
      path: '/location',
      name: 'location',
      meta: { requiresAuth: true },
      component: () =>
        import(/* webpackChunkName: "location" */ './views/Location.vue')
    },
    {
      path: '/inbox',
      name: 'inbox',
      meta: { requiresAuth: true },
      component: () =>
        import(/* webpackChunkName: "inbox" */ './views/Inbox.vue')
    },
    {
      path: '/webmail',
      name: 'webmail',
      meta: { requiresAuth: true },
      component: () =>
        import(/* webpackChunkName: "webmail" */ './views/Webmail.vue')
    },
    {
      path: '/webmail/:folder',
      name: 'webmail.folder',
      meta: { requiresAuth: true },
      component: () =>
        import(/* webpackChunkName: "webmail" */ './views/Webmail.vue')
    },
    {
      path: '/webmail/show/:id',
      name: 'webmailshow',
      meta: { requiresAuth: true },
      component: () =>
        import(/* webpackChunkName: "webmail" */ './views/WebmailShow.vue')
    },
    {
      path: '/message/:id',
      name: 'message',
      meta: { requiresAuth: true },
      component: () =>
        import(/* webpackChunkName: "inbox" */ './views/Message.vue')
    },
    {
      path: '/help',
      name: 'help',
      meta: { requiresAuth: true },
      component: () => import(/* webpackChunkName: "help" */ './views/Help.vue')
    },
    {
      path: '/helpvideo/:video/:title',
      name: 'helpvideo',
      meta: { requiresAuth: true },
      component: () =>
        import(/* webpackChunkName: "help" */ './views/HelpVideo.vue')
    },
    {
      path: '/forms',
      name: 'forms',
      meta: { requiresAuth: true },
      component: () =>
        import(/* webpackChunkName: "forms" */ './views/Forms.vue')
    },
    {
      path: '/offline-requests',
      name: 'offline-requests',
      meta: { requiresAuth: true },
      component: () =>
        import(
          /* webpackChunkName: "offline" */ './components/OfflineRequests.vue'
        )
    },
    {
      path: '/form/:form',
      name: 'form',
      props: true,
      meta: { requiresAuth: true },
      component: () =>
        import(
          /* webpackChunkName: "forms" */ './components/forms/FormPage.vue'
        )
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters['root/isLogged']) {
      next()
    } else {
      next()
      router.push({ name: 'login' })
      // store.dispatch('root/setLoginLayout')
    }
  } else {
    next()
    // store.dispatch('root/setMainLayout')
  }
})

export default router
